import { isEmpty } from 'lodash';
import { PricingDto } from '~/types/PricingDto';
import { Services } from '~/types/Services';
import { ServicesTotalPriceRequestBody } from '~/types/ServicesTotalPriceType';
import { CustomPricing, ProductMap } from '~/types/CustomPricing';
import axios from './axios';

// import services from './mock/services.json';

export const getServices = () => {
  // return Promise.resolve<Services>(services as any as Services);
  return axios.get<Services>('/stages/services').then((res) => res.data);
};

export const calculateTotalPrice = (body: ServicesTotalPriceRequestBody): Promise<PricingDto> => {
  if (isEmpty(body.selectedProducts)) {
    return Promise.resolve({});
  }
  return axios.post<PricingDto>('/stages/services/totalPrice', body).then((res) => res.data);
};

export const applyCustomPricing = (body: {
  productMap: ProductMap;
  additionalConfigurations: CustomPricing;
}) => {
  return axios.post<Services>('/stages/services/pricing', body).then((res) => res.data);
};

export const requestCustomPricing = (message: string) => {
  return axios.post<void>('/stages/services/pricing/request', { message }).then((res) => res.data);
};

export type SelectProductItem = {
  productCode: string;
  selected: boolean;
  terminals?: number;
};

export const selectProducts = (body: { products: SelectProductItem[] }) => {
  return axios
    .post<void>('/stages/services/selectProducts', body)
    .then((res) => res.data);
};
